import { Box, Typography, Paper } from "@mui/material";

export default function MaterialTile({ title, href, icon, bg = "#f5f5f5" }) {
  return (
    <Paper
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        textDecoration: "none",
        color: "inherit",
        width: "100%",
        height: "100%",
        borderRadius: 2,
        overflow: "hidden",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: 3,
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: bg,
          width: "100%",
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& svg": {
            fontSize: 64,
          },
        }}
      >
        {icon}
      </Box>
      <Box sx={{ p: 2 }}>
        <Typography align="center" fontWeight={600}>
          {title}
        </Typography>
      </Box>
    </Paper>
  );
}
